import { FunctionComponent } from 'react';
import { LabelledInfoCell } from '../../../sharedComponents/sidebar/LabelledInfoCell';
import { Arrival, CompoundLocation } from '../../compoundManagement.types';
import { DisplayCancellableData } from '../dataDisplay/DisplayCancellableData';
import { ArrivalCompletedForm } from './ArrivalCompletedForm';
import { DetailsRow } from './DetailsRow';
import { AddressDetails } from '../../../sharedComponents/AddressDetails';
import { NoValue } from '../../../sharedComponents/NoValue';
import { DisplayArrivalFreightForwarder } from '../dataDisplay/ArrivalDataContent';

export type ArrivalDetailsProps = {
    compoundVehicleId: string;
    arrival: Arrival;
    compoundLocation: CompoundLocation;
    disabled?: boolean | undefined;
};

export const ArrivalDetails: FunctionComponent<ArrivalDetailsProps> = ({
    compoundVehicleId,
    arrival,
    compoundLocation,
    disabled = false,
}) => (
    <>
        <DetailsRow className="margin-bottom-15">
            <LabelledInfoCell labelMessageId="outboundOrderBook.common.heading.from">
                <DisplayCancellableData isCancelled={arrival.isCancelled && arrival.arrivalFrom !== undefined}>
                    <AddressDetails
                        address={arrival.arrivalFrom?.address ?? {}}
                        identifier={arrival.arrivalFrom?.identifier}
                    />
                </DisplayCancellableData>
            </LabelledInfoCell>
        </DetailsRow>
        <DetailsRow className="margin-bottom-15">
            <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.carrier">
                <DisplayArrivalFreightForwarder arrival={arrival} />
            </LabelledInfoCell>
            <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.loadId">
                {arrival.transportInformation.loadId ? (
                    <DisplayCancellableData isCancelled={arrival.isCancelled}>
                        {arrival.transportInformation.loadId}
                    </DisplayCancellableData>
                ) : (
                    <NoValue />
                )}
            </LabelledInfoCell>
        </DetailsRow>
        <ArrivalCompletedForm
            key={compoundVehicleId}
            timeZone={compoundLocation.timeZone}
            compoundVehicleId={compoundVehicleId}
            disabled={disabled}
            arrivalCompletedAt={arrival.arrivalCompletedAt}
            transportInformation={arrival.transportInformation}
        />
    </>
);
